import { AppEnvironment } from "./environment-util";

export const environment: AppEnvironment = {
    imageKitCdnUrl: "https://ik.imagekit.io/highheat/",
    apiBaseUrl: "https://mqi5ns91q0.execute-api.us-east-2.amazonaws.com/prod",
};
